// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  reviewId: __t.u64().primaryKey().name("review_id"),
  subject: __t.identity(),
  reviewer: __t.identity(),
  stars: __t.u8(),
  isCaution: __t.bool().name("is_caution"),
  ref: __t.string(),
  at: __t.timestamp(),
});
